import { useEffect, useRef } from 'react';

/**
 * Hook personalizado para observar cambios de tamaño en un elemento
 * y comunicarlos al padre mediante postMessage
 * @returns {Object} ref - Referencia para adjuntar al elemento
 */
export const useResizeObserver = (onResize) => {
  const elementRef = useRef(null);
  const tickingRef = useRef(false);

  useEffect(() => {
    if (!elementRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      if (!tickingRef.current) {
        tickingRef.current = true;

        window.requestAnimationFrame(() => {
          if (!elementRef.current) return;

          const height = elementRef.current.getBoundingClientRect().height;
          // Ejecutar callback si existe
          if (typeof onResize === 'function') {
            onResize(height);
          }

          window.parent.postMessage({ type: 'embed-size', height }, '*');
          tickingRef.current = false;
        });
      }
    });

    resizeObserver.observe(elementRef.current);
    
    return () => resizeObserver.disconnect();
  }, [onResize]);

  return elementRef;
};